// src/adminComponents/FloatingVerticalMenu.js
import React, { useEffect } from 'react';
import { IconButton, Paper, Tooltip } from '@mui/material';
import DashboardIcon from '@mui/icons-material/Dashboard';
import AssignmentIcon from '@mui/icons-material/Assignment';
import PeopleIcon from '@mui/icons-material/People';
import WorkOffIcon from '@mui/icons-material/WorkOff';

const FloatingVerticalMenu = ({ selectedMenu, onMenuSelect }) => {
  useEffect(() => {
    // Notify parent component about the selected menu when it changes
    onMenuSelect(selectedMenu);
    // Update sessionStorage with the new selected menu
    sessionStorage.setItem('selectedMenu', selectedMenu);
  }, [selectedMenu, onMenuSelect]);

  const handleMenuSelect = (menu) => {
    onMenuSelect(menu);
  };

  return (
    <Paper
      sx={{
        position: 'fixed',
        top: '49%',
        left: '16px',
        width: '60px',
        transform: 'translateY(-50%)',
        padding: '16px',
        display: 'flex',
        flexDirection: 'column',
        gap: '25px',
        borderRadius: '16px',
      }}
    >
      <Tooltip title="Dashboard" placement="right" arrow>
        <IconButton
          onClick={() => handleMenuSelect('dashboard')}
          sx={{
            color: selectedMenu === 'dashboard' ? '#39B54A' : 'grey',
            '&:hover': {
              color: '#39B54A',
            },
          }}
        >
          <DashboardIcon />
        </IconButton>
      </Tooltip>
      <Tooltip title="Leave Management" placement="right" arrow>
        <IconButton
          onClick={() => handleMenuSelect('leaveManagement')}
          sx={{
            color: selectedMenu === 'leaveManagement' ? '#39B54A' : 'grey',
            '&:hover': {
              color: '#39B54A',
            },
          }}
        >
          <WorkOffIcon />
        </IconButton>
      </Tooltip>
      <Tooltip title="Tasks" placement="right" arrow>
        <IconButton
          onClick={() => handleMenuSelect('tasks')}
          sx={{
            color: selectedMenu === 'tasks' ? '#39B54A' : 'grey',
            '&:hover': {
              color: '#39B54A',
            },
          }}
        >
          <AssignmentIcon />
        </IconButton>
      </Tooltip>
      <Tooltip title="Employees" placement="right" arrow>
        <IconButton
          onClick={() => handleMenuSelect('employees')}
          sx={{
            color: selectedMenu === 'employees' ? '#39B54A' : 'grey',
            '&:hover': {
              color: '#39B54A',
            },
          }}
        >
          <PeopleIcon />
        </IconButton>
      </Tooltip>
    </Paper>
  );
};

export default FloatingVerticalMenu;
